import { render, staticRenderFns } from "./Practitioner.vue?vue&type=template&id=40f76db0&"
import script from "./Practitioner.vue?vue&type=script&lang=ts&"
export * from "./Practitioner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports